// extracted by mini-css-extract-plugin
export default {"productDescription":"b_-z","featuredDescription":"c_-z","description":"d_-z","more":"e_-z","descriptionSku":"f_-z"};